import React from 'react';
import HeadingDots from './HeadingDots';

const steps = [
  {
    n: '1',
    img: '/spiick_imgs/method/listen.png',
    title: 'Listen',
    body: 'Your child hears natural sentences, just like in real life, through activities crafted for meaningful exposure, everyday vocabulary, and real language patterns.'
  },
  {
    n: '2',
    img: '/spiick_imgs/method/speak.png',
    title: 'Speak',
    body: 'Spiick, the interactive pen, encourages your child to speak and express themselves through guided prompts, real-life situations, and instant, supportive feedback that builds confidence naturally.'
  },
  {
    n: '3',
    img: '/spiick_imgs/method/play.png',
    title: 'Play & Progress',
    body: 'Spiick corrects and motivates like a real teacher, turning every interaction into a game-like experience where your child learns, improves, and builds lasting confidence step by step.'
  }
];

export default function SpiickMethod() {
  return (
    <section id="method" className="relative w-full bg-white pt-10 lg:pt-14 pb-10 lg:pb-14">
      <div className="max-w-[1180px] mx-auto px-6 lg:px-10">
        <div className="text-center">
          <h2
            className="text-[52px] sm:text-[60px] lg:text-[72px] leading-[1.02] text-[#0c0a1a] tracking-tight"
            style={{ fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 800, letterSpacing: '-0.03em' }}
          >
            The Spiick{' '}
            <span className="relative inline-block align-baseline whitespace-nowrap">
              <svg
                aria-hidden="true"
                viewBox="0 0 220 80"
                preserveAspectRatio="none"
                className="absolute -left-[6%] -right-[6%] top-[14%] -bottom-[10%] w-[112%] h-[96%] z-0 pointer-events-none"
              >
                <path
                  d="M9 32 C 30 22, 70 18, 112 16 C 150 14, 190 18, 213 26 C 218 38, 214 54, 208 64 C 175 72, 130 71, 92 70 C 60 70, 24 68, 7 60 C 2 50, 4 38, 9 32 Z"
                  fill="#abf1b2"
                  opacity="0.72"
                />
              </svg>
              <span className="relative z-10" style={{ color: '#004867' }}>method</span>
            </span>
          </h2>
        </div>

        <div className="mt-14 lg:mt-16 grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 lg:gap-12">
          {steps.map((s, i) => (
            <div key={s.n} className={`flex flex-col items-center text-center ${i === 1 ? 'md:-translate-y-[8%]' : ''}`}>
              {/* Number badge */}
              <span className="w-12 h-12 lg:w-14 lg:h-14 rounded-full bg-[#F24540] grid place-items-center text-white text-[20px] lg:text-[22px] font-semibold shadow-[0_8px_20px_-8px_rgba(242,69,64,0.6)]">
                {s.n}
              </span>

              {/* Image */}
              <img
                src={s.img}
                alt={s.title}
                className="mt-6 w-full max-w-[320px] aspect-square object-contain"
              />

              {/* Title */}
              <h3
                className="mt-6 text-[36px] lg:text-[40px] leading-tight tracking-tight"
                style={{ fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 800, letterSpacing: '-0.02em' }}
              >
                <span className="relative inline-block align-baseline whitespace-nowrap">
                  <svg
                    aria-hidden="true"
                    viewBox="0 0 220 80"
                    preserveAspectRatio="none"
                    className="absolute -left-[6%] -right-[6%] top-[14%] -bottom-[10%] w-[112%] h-[96%] z-0 pointer-events-none"
                  >
                    <path
                      d="M9 32 C 30 22, 70 18, 112 16 C 150 14, 190 18, 213 26 C 218 38, 214 54, 208 64 C 175 72, 130 71, 92 70 C 60 70, 24 68, 7 60 C 2 50, 4 38, 9 32 Z"
                      fill="#f8d768"
                      opacity="0.72"
                    />
                  </svg>
                  <span className="relative z-10" style={{ color: '#0c0a1a' }}>{s.title}</span>
                </span>
              </h3>

              {/* Body */}
              <p
                className="mt-4 text-[15px] lg:text-[16px] leading-relaxed text-[#444251] max-w-[340px]"
                style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 400 }}
              >
                {s.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
